var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useTranslation } from "react-i18next";
export function KioskCheckCoupon(props) {
    var onClose = props.onClose, onSearch = props.onSearch;
    var _a = useTranslation(), t = _a.t, i18n = _a.i18n;
    var _b = useState(''), code = _b[0], setCode = _b[1];
    var handleNumberClick = function (number) {
        setCode(function (prevCode) { return prevCode + number; });
    };
    var handleBackspaceClick = function () {
        setCode(function (prevCode) { return prevCode.slice(0, -1); });
    };
    var handleClearClick = function () {
        setCode('');
    };
    var handleSearchClick = function () {
        onSearch(code);
    };
    return (_jsxs("div", __assign({ className: "kiosk-check-coupon" }, { children: [_jsx("input", { className: "check-coupon-input", type: "number", placeholder: "ID", value: code, onChange: function (e) { return setCode(e.target.value); } }, void 0), _jsxs("div", __assign({ className: "check-coupon-numbers" }, { children: [Array.from({ length: 9 }, function (_, index) {
                        return (_jsx("div", __assign({ className: "check-coupon-number", onClick: function () { return handleNumberClick(index + 1); } }, { children: index + 1 }), index));
                    }), _jsx("div", __assign({ className: "check-coupon-number clear", onClick: handleClearClick }, { children: "X" }), void 0), _jsx("div", __assign({ className: "check-coupon-number", onClick: function () { return handleNumberClick(0); } }, { children: "0" }), void 0), _jsx("div", __assign({ className: "check-coupon-number backspace", onClick: handleBackspaceClick }, { children: '<' }), void 0)] }), void 0), _jsx("button", __assign({ className: "check-coupon-button", onClick: handleSearchClick, disabled: code.length === 0 }, { children: t('coupon.search') }), void 0)] }), void 0));
}
